import React from "react";
import type { IconType } from "react-icons";
import { FiClipboard, FiGift, FiUserPlus } from "react-icons/fi";

const steps: { number: string; title: string; description: string; icon: IconType }[] = [
  {
    number: "01",
    title: "Sign Up",
    description: "Join now and complete the short registration profile.",
    icon: FiUserPlus,
  },
  {
    number: "02",
    title: "Take Surveys",
    description: "Receive survey invitations via email and complete it on any device.",
    icon: FiClipboard,
  },
  {
    number: "03",
    title: "Get Rewarded",
    description: "Get instant gift cards from multiple retailers and track your earnings in one dashboard.",
    icon: FiGift,
  },
];

export const Step = () => {
  return (
    <section className="py-16 border-y bg-surface border-line sm:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <p className="zs-eyebrow">How it works</p>
          <h2 className="mt-1 text-3xl font-bold tracking-tight font-display text-ink sm:text-4xl">How It Works</h2>
          <p className="mt-4 text-base leading-relaxed sm:text-lg text-ink-2">
            Quick surveys. Instant rewards. A community that values your time.
          </p>
        </div>

        <ol className="relative grid gap-8 mt-12 sm:mt-16 md:grid-cols-3 md:gap-6">
          {/* Connector between the step markers on wide screens. */}
          <span
            aria-hidden="true"
            className="absolute hidden h-px md:block top-12 left-[16.66%] right-[16.66%] bg-line-strong"
          />
          {steps.map(({ number, title, description, icon: Icon }) => (
            <li key={number} className="relative flex items-start gap-4 md:flex-col md:items-center md:gap-0 md:text-center">
              <span className="relative z-10 flex items-center justify-center text-xl border rounded-lg shadow-sm w-14 h-14 shrink-0 bg-surface border-line text-primary-text md:w-24 md:h-24 md:text-3xl md:rounded-xl">
                <Icon aria-hidden="true" />
              </span>
              <div className="min-w-0 md:mt-5">
                <span className="text-xs font-semibold tracking-widest tabular-nums text-primary-text">STEP {number}</span>
                <h3 className="mt-1 text-lg font-semibold font-display text-ink">{title}</h3>
                <p className="max-w-xs mt-2 text-sm leading-relaxed text-ink-2 md:mx-auto">{description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
